<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('probesetting.pageTitleText') }}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :rowClassInfo="rowClassInfo"
            :viewSlotInfo="viewSlotInfo"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="hostname"
            :primarySearchKeyI18="$t('probesetting.hostname')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";

export default {
    name: "ProbeSetting",
    components: { RcmTable, TagList },
    data() {
        return {
            viewSlotInfo: {
                edgeclients: []
            },
            recordLineOptions: [],
            esIndex: "rcm-probes",
            drawerTitleKey: "hostname",
            sort: [{ modifiedDate: { order: "desc" } }],
            nodesNames: [],
            rowClassInfo: {
                key: "status",
                values: [],
                valuesNot: ["運行中"],
                className: "table-disabled-row",
                defaultClassName: ""
            },
            esIndexFields: {
                action: {},
                settingZoneExplain: {},
                hostname: { sectionKey: "essential" },
                serviceIP: {},
                description: { sectionKey: "essential" },
                // "groupName",
                // "internalIP",
                // "externalIP",
                // "health",
                // "isenabled",
                // "serviceIP",
                // "serviceProvideType",
                // "connectState",
                // "gitSitesSuccess",
                // "nginxIsRunning",
                status: {}
            }
        };
    },
    computed: {
        addButtonText() {
            return "Create";
        },
        sectionInfo() {
            let sectionInfo = [{ sectionKey: "essential", isOpened: true }];

            sectionInfo = sectionInfo.map(e => {
                e.sectionName = this.$i18n.t(`probesetting.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        }
    },
    methods: {},
    mounted() {},
    sockets: {},
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, busEvent => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    }
};
</script>



// WEBPACK FOOTER //
// src/view/ProbeSetting/Page.vue